// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"412":"d273d85e6ff38e8b","7504":"3c982e138306768b"}[chunkId] + ".js";
};